export default __webpack_public_path__ + "static/icon-14-6-836839aa2addaff9e7efc298a6677afe.png";